<main class="fill-shell" lang="ckb" dir="rtl">
  <section class="form-panel">
    <header class="header">
      <p class="kicker">فۆرمی سیڤیی گشتی</p>
      <h1>پڕکردنەوەی سیڤی</h1>
      <p>ئەم فۆرمە تەنها جارێک دەنێردرێت. تکایە ژمارەی تەلەفۆنی ڕاست بنووسە.</p>
    </header>

    <form class="form" (submit)="submit($event)">
      <section class="form-section">
        <h2>زانیاری سەرەکی</h2>
        <div class="grid two">
          <label class="field">
            <span>ناوی یەکەم *</span>
            <input type="text" [value]="firstName()" (input)="updateField('firstName', $event)" required />
          </label>
          <label class="field">
            <span>ناوی دووەم *</span>
            <input type="text" [value]="secondName()" (input)="updateField('secondName', $event)" required />
          </label>
          <label class="field">
            <span>ناوی سێیەم</span>
            <input type="text" [value]="thirdName()" (input)="updateField('thirdName', $event)" />
          </label>
          <label class="field">
            <span>ژمارەی تەلەفۆن *</span>
            <input type="tel" [value]="phoneNumber()" (input)="updateField('phoneNumber', $event)" required />
          </label>
          <label class="field">
            <span>ئیمەیڵ</span>
            <input type="email" [value]="email()" (input)="updateField('email', $event)" />
          </label>
          <label class="field">
            <span>ناونیشانی شوێن</span>
            <input type="text" [value]="streetAddress()" (input)="updateField('streetAddress', $event)" />
          </label>
          <label class="field">
            <span>ناونیشانی سیڤی *</span>
            <input type="text" [value]="title()" (input)="updateField('title', $event)" required placeholder="بۆ نموونە: سیڤیی فرۆشیار" />
          </label>
          <label class="field">
            <span>شار *</span>
            <input type="text" [value]="city()" (input)="updateField('city', $event)" required />
          </label>
          <label class="field">
            <span>وڵات *</span>
            <input type="text" [value]="country()" (input)="updateField('country', $event)" required />
          </label>
          <label class="field">
            <span>کۆدی پۆستە</span>
            <input type="text" [value]="zipcode()" (input)="updateField('zipcode', $event)" />
          </label>
        </div>

        <div class="grid one">
          <label class="field">
            <span>سەردێڕی پیشەیی</span>
            <input type="text" [value]="headline()" (input)="updateField('headline', $event)" placeholder="پوختەیەکی کورت لەسەر خۆت" />
          </label>
          <label class="field">
            <span>تێبینی</span>
            <textarea [value]="notes()" (input)="updateField('notes', $event)" placeholder="هەر زانیارییەکی زیادە"></textarea>
          </label>
        </div>
      </section>

      <section class="form-section">
        <h2>چاوەڕوانی مووچە</h2>
        <div class="grid three">
          <label class="field">
            <span>کەمترین مووچە</span>
            <input type="number" [value]="preferredSalaryMin()" (input)="updateField('preferredSalaryMin', $event)" />
          </label>
          <label class="field">
            <span>زۆرترین مووچە</span>
            <input type="number" [value]="preferredSalaryMax()" (input)="updateField('preferredSalaryMax', $event)" />
          </label>
          <label class="field">
            <span>دراو</span>
            <select [value]="preferredSalaryCurrency()" (change)="updateField('preferredSalaryCurrency', $event)">
              <option value="IQD">IQD</option>
              <option value="USD">USD</option>
            </select>
          </label>
        </div>
      </section>

      <section class="form-section desired-block">
        <h2>پۆستە ئارەزوومەندەکان</h2>
        @if (isLoading()) {
          <p>هەڵبژاردەکان بار دەکرێن...</p>
        } @else if (!desiredPositionTypes().length) {
          <p>لە ئێستادا هیچ پۆستێک بەردەست نییە.</p>
        } @else {
          <div class="desired-grid">
            @for (item of desiredPositionTypes(); track desiredTypeID(item)) {
              <label class="desired-item">
                <input type="checkbox" [checked]="isDesiredPositionSelected(desiredTypeID(item))" (change)="toggleDesiredPosition(desiredTypeID(item), $event)" />
                <span>
                  <strong>{{ item.name }}</strong>
                  @if (item.description) {
                    <small>{{ item.description }}</small>
                  }
                </span>
              </label>
            }
          </div>
        }
      </section>

      <section class="form-section">
        <div class="section-row">
          <h2>شارەزاییەکان</h2>
        </div>
        <div class="dynamic-list">
          @for (skill of skills(); track $index; let i = $index) {
            <div class="dynamic-row three-up">
              <label class="field">
                <span>ناوی شارەزایی</span>
                <input type="text" [value]="skill.name" (input)="updateSkill(i, 'name', $any($event.target).value)" />
              </label>
              <label class="field">
                <span>ئاست</span>
                <select [value]="skill.level" (change)="updateSkill(i, 'level', $any($event.target).value)">
                  <option value="BEGINNER">سەرەتایی</option>
                  <option value="INTERMEDIATE">ناوەند</option>
                  <option value="ADVANCED">پێشکەوتوو</option>
                  <option value="EXPERT">شارەزا</option>
                </select>
              </label>
              <label class="field">
                <span>ساڵ</span>
                <input type="number" [value]="skill.yearsOfExperience ?? ''" (input)="updateSkill(i, 'yearsOfExperience', $any($event.target).value)" />
              </label>
              <button type="button" class="tiny-btn danger" (click)="removeSkill(i)">لابردن</button>
            </div>
          }
        </div>
        <div class="add-under-row">
          <button type="button" class="tiny-btn" (click)="addSkill()">+ زیادکردنی شارەزایی</button>
        </div>
      </section>

      <section class="form-section">
        <div class="section-row">
          <h2>مێژووی کار</h2>
        </div>
        <div class="dynamic-list">
          @for (job of jobHistories(); track $index; let i = $index) {
            <div class="card-item">
              <div class="card-head">
                <strong>کار #{{ i + 1 }}</strong>
                <button type="button" class="tiny-btn danger" (click)="removeJobHistory(i)">لابردن</button>
              </div>
              <div class="grid two">
                <label class="field">
                  <span>ناوی شوێنی کار *</span>
                  <input type="text" [value]="job.employerName" (input)="updateJobHistory(i, 'employerName', $any($event.target).value)" />
                </label>
                <label class="field">
                  <span>ناونیشانی کار *</span>
                  <input type="text" [value]="job.jobTitle" (input)="updateJobHistory(i, 'jobTitle', $any($event.target).value)" />
                </label>
                <label class="field">
                  <span>شوێن</span>
                  <input type="text" [value]="job.location" (input)="updateJobHistory(i, 'location', $any($event.target).value)" />
                </label>
                <label class="field">
                  <span>بەرواری دەستپێک *</span>
                  <input type="date" [value]="job.startedAt" (input)="updateJobHistory(i, 'startedAt', $any($event.target).value)" />
                </label>
                <label class="field">
                  <span>ئێستا لەم کارەدایم</span>
                  <input type="checkbox" [checked]="job.isCurrent" (change)="updateJobHistory(i, 'isCurrent', $any($event.target).checked)" />
                </label>
                @if (!job.isCurrent) {
                  <label class="field">
                    <span>بەرواری کۆتایی</span>
                    <input type="date" [value]="job.endedAt" (input)="updateJobHistory(i, 'endedAt', $any($event.target).value)" />
                  </label>
                }
                <label class="field full">
                  <span>بەرپرسیارێتییەکان</span>
                  <textarea [value]="job.responsibilities" (input)="updateJobHistory(i, 'responsibilities', $any($event.target).value)"></textarea>
                </label>
              </div>
            </div>
          }
        </div>
        <div class="add-under-row">
          <button type="button" class="tiny-btn" (click)="addJobHistory()">+ زیادکردنی کار</button>
        </div>
      </section>

      <section class="form-section">
        <div class="section-row">
          <h2>پڕۆژەکان</h2>
          <button type="button" class="tiny-btn" (click)="addProject()">+ زیادکردنی پڕۆژە</button>
        </div>
        <div class="dynamic-list">
          @for (project of projects(); track $index; let i = $index) {
            <div class="card-item">
              <div class="card-head">
                <strong>پڕۆژە #{{ i + 1 }}</strong>
                <button type="button" class="tiny-btn danger" (click)="removeProject(i)">لابردن</button>
              </div>
              <div class="grid two">
                <label class="field">
                  <span>ناوی پڕۆژە</span>
                  <input type="text" [value]="project.name" (input)="updateProjectName(i, $any($event.target).value)" />
                </label>
                <label class="field">
                  <span>بەرواری پڕۆژە</span>
                  <input type="date" [value]="project.date" (input)="updateProjectDate(i, $any($event.target).value)" />
                </label>
              </div>
              <div class="details-wrap">
                <div class="section-row">
                  <span class="details-title">وردەکارییەکان</span>
                  <button type="button" class="tiny-btn" (click)="addProjectDetail(i)">+ زیادکردنی وردەکاری</button>
                </div>
                @for (detail of project.details; track $index; let di = $index) {
                  <div class="detail-row">
                    <input type="text" [value]="detail" (input)="updateProjectDetail(i, di, $any($event.target).value)" />
                    <button type="button" class="tiny-btn danger" (click)="removeProjectDetail(i, di)">لابردن</button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </section>

      @if (errorMessage()) {
        <p class="msg err">{{ errorMessage() }}</p>
      }
      @if (successMessage()) {
        <p class="msg ok">{{ successMessage() }}</p>
      }

      <footer class="actions">
        <a routerLink="/" class="ghost">گەڕانەوە</a>
        <button type="submit" class="primary" [disabled]="isSubmitting()">
          {{ isSubmitting() ? 'ناردن...' : 'ناردنی سیڤی' }}
        </button>
      </footer>
    </form>
  </section>
</main>
